import { render, staticRenderFns } from "./custom-clinro-since-last-visit.vue?vue&type=template&id=b379d8b2&scoped=true&"
import script from "./custom-clinro-since-last-visit.vue?vue&type=script&lang=js&"
export * from "./custom-clinro-since-last-visit.vue?vue&type=script&lang=js&"
import style0 from "./custom-clinro-since-last-visit.vue?vue&type=style&index=0&id=b379d8b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b379d8b2",
  null
  
)

component.options.__file = "custom-clinro-since-last-visit.vue"
export default component.exports